import { EVENT_CONFIG } from "@/config/eventConfig";
import { Reveal, GoldButton, useDonate } from "./shared";

const FinalCTA = () => {
  const { openDonate } = useDonate();
  const { urls, images } = EVENT_CONFIG;

  return (
    <section data-testid="final-cta-section" className="relative py-32 sm:py-44 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center slow-zoom"
        style={{ backgroundImage: `url(${images.toast})` }}
      />
      <div className="absolute inset-0 bg-ink/85" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(91,18,30,0.35),transparent_65%)]" />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 text-center flex flex-col items-center gap-8">
        <Reveal>
          <p className="font-script text-4xl sm:text-6xl text-champagne">Every crown has a story.</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif text-3xl sm:text-5xl lg:text-6xl tracking-tight text-ivory leading-[1.08]">
            WHAT WILL <span className="gold-shimmer">YOURS</span> BUILD?
          </h2>
        </Reveal>
        <Reveal delay={0.2} className="flex flex-col sm:flex-row flex-wrap justify-center gap-4 mt-2">
          <GoldButton testid="final-buy-ticket-button" href={urls.buyTickets} external>
            Buy Your Ticket
          </GoldButton>
          <GoldButton testid="final-make-gift-button" variant="outline" onClick={() => openDonate()}>
            Make a Gift
          </GoldButton>
          <GoldButton testid="final-sponsor-button" variant="outline" href="#sponsor">
            Become a Sponsor
          </GoldButton>
          <GoldButton testid="final-after-party-button" variant="wine" href="#after-party">
            Attend the After Party
          </GoldButton>
        </Reveal>
        <Reveal delay={0.3} className="mt-6">
          <p className="text-[11px] sm:text-xs uppercase tracking-[0.4em] text-gold">
            Building Crowns 4 The Future
          </p>
          <p className="mt-3 text-cream/80 text-sm sm:text-base">
            A night of elegance. A mission with heart.
          </p>
          <p className="mt-1 text-cream/60 text-sm italic">
            Because every child's crown deserves to shine.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
